<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M18.8957 11.005H7.72573L12.6057 6.12498C12.9957 5.73498 12.9957 5.09498 12.6057 4.70498C12.2157 4.31498 11.5857 4.31498 11.1957 4.70498C8.93242 6.96829 8.25684 7.64844 4.10449 12C9.34681 17.4476 9.87617 17.9754 11.1957 19.295C11.5857 19.685 12.2157 19.685 12.6057 19.295C12.9957 18.905 12.9957 18.275 12.6057 17.885L7.72573 13.005H18.8957C19.4457 13.005 19.8957 12.555 19.8957 12.005C19.8957 11.455 19.4457 11.005 18.8957 11.005Z"
		fill="currentColor"
	/>
</svg>
